import { CurationsContainerMode } from "@holibob-packages/ui-core/curation";

import { useEntityConfigurationValueByKey } from "./useEntityConfiguration";

export function useCurationsListViewMode(): CurationsContainerMode {
    return useEntityConfigurationValueByKey("SETTING.CURATION_VIEW_MODE") ?? "grid";
}
